module.exports = __webpack_public_path__ + "img/hot-all.9053ae42.png";